// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** Anguilla */
const AI: PhoneNumberData = [1, 'AI', 10, format0, /^(?:264)/];

export default AI;
